module.exports = __webpack_public_path__ + "img/brand--farmacias-peruanas.dd137446.png";